import axios from 'axios';
import { API_MYEDUZZ } from 'settings';

import type { IGlpiPayload } from 'v2/interfaces/glpiTicketApproval';

export class GlpiTicketApprovalService {
  public async moderateTicket(ticket_id: number, payload: IGlpiPayload) {
    const response = await axios({
      baseURL: API_MYEDUZZ,
      url: `/glpi/ticket/${ticket_id}/moderation`,
      method: 'POST',
      data: payload,
    });
    return response;
  }
}

const glpiTicketApprovalService = new GlpiTicketApprovalService();

export default glpiTicketApprovalService;
